import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  fill1?: string;
  fill2?: string;
  onClick?: (e: MouseEvent) => void;
};
const SingleBed = forwardRef<SVGSVGElement, Props>(
  ({ className, fill1 = "#9B5757", fill2 = "#B6917E", onClick }, ref) => (
    <svg
      width="18"
      height="18"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={className}
      onClick={onClick}
      ref={ref}
    >
      <path
        fill={fill2}
        d="M317.535,246.813h-123.07c-20.728,0-37.532-16.804-37.532-37.532v-65.731
   c0-20.728,16.804-37.532,37.532-37.532h123.07c20.728,0,37.532,16.804,37.532,37.532v65.731
   C355.067,230.008,338.264,246.813,317.535,246.813z"
      />
      <g>
        <path
          fill={fill1}
          d="M317.535,264.597h-123.07c-30.5,0-55.317-24.815-55.317-55.317v-65.731
       c0-30.502,24.815-55.317,55.317-55.317h123.07c30.5,0,55.317,24.815,55.317,55.317v65.731
       C372.851,239.782,348.037,264.597,317.535,264.597z M194.465,123.802c-10.889,0-19.748,8.858-19.748,19.748v65.731
       c0,10.889,8.858,19.748,19.748,19.748h123.07c10.888,0,19.748-8.858,19.748-19.748v-65.731c0-10.889-8.858-19.748-19.748-19.748
       L194.465,123.802L194.465,123.802z"
        />
        <path
          fill={fill1}
          d="M52.194,504.983c-0.638,0-1.277-0.011-1.919-0.034C22.083,503.946,0,480.688,0,451.998V250.915
       c0-26.616,21.654-48.27,48.27-48.27H463.73c26.616,0,48.27,21.654,48.27,48.27v201.906c0,28.761-23.399,52.16-52.16,52.16
       s-52.16-23.399-52.16-52.16v-43.597c0-9.822,7.964-17.784,17.784-17.784c9.821,0,17.784,7.962,17.784,17.784v43.597
       c0,9.148,7.443,16.591,16.591,16.591c9.148,0,16.591-7.443,16.591-16.591V250.915c0-7.004-5.698-12.702-12.702-12.702H48.27
       c-7.003,0-12.702,5.698-12.702,12.702v201.083c0,9.283,7.164,17.091,15.969,17.404c4.556,0.151,8.874-1.485,12.141-4.638
       c3.271-3.157,5.072-7.398,5.072-11.94v-43.597c0-9.822,7.962-17.784,17.784-17.784h237.041c9.821,0,17.784,7.962,17.784,17.784
       c0,9.822-7.964,17.784-17.784,17.784H104.321v25.812c0,14.284-5.663,27.614-15.942,37.534
       C78.564,499.831,65.777,504.983,52.194,504.983z"
        />
        <path
          fill={fill1}
          d="M464.073,237.319H47.927c-9.822,0-17.784-7.962-17.784-17.784v-92.473
       c0-66.193,53.853-120.045,120.045-120.045h27.566c9.822,0,17.784,7.962,17.784,17.784s-7.962,17.784-17.784,17.784h-27.566
       c-46.581,0-84.476,37.897-84.476,84.476v74.689h380.577v-74.689c0-46.581-37.897-84.476-84.476-84.476h-82.091
       c-9.821,0-17.784-7.962-17.784-17.784s7.964-17.784,17.784-17.784h82.091c66.193,0,120.045,53.853,120.045,120.045v92.473
       C481.857,229.357,473.893,237.319,464.073,237.319z"
        />
      </g>
      <path
        fill={fill2}
        d="M494.216,313.797v-62.882c0-16.836-13.65-30.486-30.486-30.486H48.27
   c-16.836,0-30.486,13.65-30.486,30.486v62.882H494.216z"
      />
      <path
        fill={fill1}
        d="M494.216,331.582H17.784C7.962,331.582,0,323.62,0,313.797v-62.882
   c0-26.616,21.654-48.27,48.27-48.27H463.73c26.616,0,48.27,21.654,48.27,48.27v62.882C512,323.62,504.038,331.582,494.216,331.582z
    M35.569,296.013h440.862v-45.098c0-7.003-5.698-12.702-12.702-12.702H48.27c-7.003,0-12.702,5.698-12.702,12.702V296.013z"
      />
    </svg>
  ),
);

export default SingleBed;
